export { default as UtilityService} from './utility.service';
export { default as SystemServices } from './system.service';
export { default as CustomerServices } from './customer.service';
export { default as MeetingNotesServices } from './meetingNotes.service';
export { default as StyleServices } from './style.service';
export { default as SampleServices } from './sample.service';
export { default as CostingServices } from './costing.service';
export { default as PermissionServices } from './permission.service';
export { default as DevelopmentServices } from './development.service';
export { default as CommunicationServices } from './communication.service';
export { default as CountryServices } from './country.service';
export { default as ReportServices } from './report.service';
export { default as FileUploadService } from './fileupload.service';

export { default as EmployeeSampleServices } from './employeesample.service';
export { default as NewSampleRequestServices } from './newsamplerequest.service';
export { default as NewDashboardServices } from './newdashboard.service';



// WEBPACK FOOTER //
// ./src/services/index.js